import { safeHttpUrl } from '@clh/util';

export function openExternalUrl(value: string | null | undefined): void {
    const url = safeHttpUrl(value);

    if (url) {
        window.open(url, '_blank', 'noopener,noreferrer');
    }
}
